import { PAGE_SIZE } from '../../constants/schedule';

export function getPagination(page = 0) {
  return {
    limit: PAGE_SIZE,
    offset: page * PAGE_SIZE,
  };
}
